import { useCallback } from 'react';

import { getDecks } from './decks.ts';
import { useServerResource } from './use-server-resource.ts';

export function useAuthenticatedDecks(userId: string | null) {
  const enabled = userId !== null;
  const fetchDecks = useCallback(
    (signal: AbortSignal) =>
      enabled ? getDecks(fetch, signal) : Promise.resolve([]),
    [enabled],
  );
  const shouldPoll = useCallback(() => false, []);
  return useServerResource(
    `authenticated-decks:${userId ?? 'anonymous'}`,
    fetchDecks,
    0,
    shouldPoll,
  );
}
